import reduce from 'lodash/reduce'
import snakeCase from 'lodash/snakeCase'

export function buildFilters(filters, prefix = 'filter') {
  return reduce(
    filters,
    (acc, filter, key) => {
      if (filter.value !== '' && filter.value !== undefined && filter.value !== null) {
        acc[`${prefix}[${snakeCase(key)}]`] = filter.value
      }

      return acc
    },
    {}
  )
}
